import { create } from "zustand";
import type { ChatWithLastAttendance, DocID } from "@/types";

type TargetChatState = {
  // Chat já buscado no clique do contato, aguardando ser aberto em /chats.
  targetChat: ChatWithLastAttendance | null;
  // Setor de origem — usado para descartar alvos fantasma após troca de setor.
  targetSectorId: DocID | null;
  setTarget: (chat: ChatWithLastAttendance, sectorId: DocID) => void;
  clear: () => void;
};

export const useTargetChatStore = create<TargetChatState>((set) => ({
  targetChat: null,
  targetSectorId: null,
  setTarget: (chat, sectorId) =>
    set({ targetChat: chat, targetSectorId: sectorId }),
  clear: () => set({ targetChat: null, targetSectorId: null }),
}));
